import { useState } from "react";
import API from "../api";

const ReportFire = () => {
  const [formData, setFormData] = useState({
    location: "",
    latitude: "",
    longitude: "",
    description: "",
    image: null,
  });

  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    if (e.target.name === "image") {
      setFormData({ ...formData, image: e.target.files[0] });
    } else {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = new FormData();
    data.append("latitude", formData.latitude);
    data.append("longitude", formData.longitude);

    // These are required by your ML model
    data.append("temperature", 35);
    data.append("humidity", 40);
    data.append("wind_speed", 10);
    data.append("vegetation", 0.6);

    // Optional fields
    data.append("location", formData.location);
    data.append("description", formData.description);

    if (formData.image) {
      data.append("image", formData.image);
    }

    try {
      await API.post("/predict", data, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      setMessage("Fire report submitted successfully.");

      // Reset form
      setFormData({
        location: "",
        latitude: "",
        longitude: "",
        description: "",
        image: null,
      });
    } catch (error) {
      console.error(error);
      setMessage("Error submitting fire report.");
    }
  };

  return (
    <div className="report-container">
      <div className="report-card">
        <h1>Report a New Fire Incident</h1>
        <p className="subtitle">
          Please provide accurate location details for immediate action.
        </p>

        <form onSubmit={handleSubmit}>
          {/* LOCATION */}
          <label>Location Name / Address</label>
          <input
            type="text"
            name="location"
            value={formData.location}
            onChange={handleChange}
            placeholder="e.g., Forest Zone 3"
            required
          />

          {/* LAT & LNG */}
          <div className="row">
            <div>
              <label>Latitude</label>
              <input
                type="number"
                step="any"
                name="latitude"
                value={formData.latitude}
                onChange={handleChange}
                required
              />
            </div>

            <div>
              <label>Longitude</label>
              <input
                type="number"
                step="any"
                name="longitude"
                value={formData.longitude}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          {/* DESCRIPTION RESTORED */}
          <label>Incident Description</label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
            placeholder="Size of fire, smoke visibility, wind direction, etc."
          />

          {/* IMAGE UPLOAD */}
          <label>Upload Fire Image</label>
          <input
            type="file"
            name="image"
            accept="image/*"
            onChange={handleChange}
          />

          <button type="submit">Submit Fire Report</button>
        </form>

        {message && <p className="response-message">{message}</p>}
      </div>
    </div>
  );
};

export default ReportFire;
